import { render, staticRenderFns } from "./AddCoinsDialog.vue?vue&type=template&id=3c965c53&scoped=true&"
import script from "./AddCoinsDialog.vue?vue&type=script&lang=js&"
export * from "./AddCoinsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c965c53",
  null
  
)

export default component.exports